export const MultiAssetPair: string[] = ['eth/sol', 'sol/eth', 'eth/btc']
